exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.remaining-price[data-v-7fb9430e] {\n  text-align: end;\n}\n.transactions-overcharge[data-v-7fb9430e] {\n  font-size: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.btn-radio[data-v-7fb9430e] {\n  left: 19px !important;\n}\n.charge-amount[data-v-7fb9430e] {\n  line-height: 2.3;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7fb9430e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/transactions/TransactionsModal.vue
// module id = n8hL
// module chunks = 0